import { render } from "./CustomerAttendanceReport.vue?vue&type=template&id=4fb6d60f&ts=true"
import script from "./CustomerAttendanceReport.vue?vue&type=script&lang=ts"
export * from "./CustomerAttendanceReport.vue?vue&type=script&lang=ts"

import "./CustomerAttendanceReport.vue?vue&type=style&index=0&id=4fb6d60f&lang=css"

import exportComponent from "/Users/trend/MANARATFOUNDATION/KRC-FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__